import { renderPublicHtmlDocument, } from "../adapters/prerender/index.js";
export function getPublicSsgPageOutputPath(routePath) {
    return routePath === "/"
        ? "index.html"
        : `${routePath.replace(/^\//, "")}/index.html`;
}
export async function createPublicStaticSiteArtifacts(options) {
    if ((options.renderMarkdown === undefined) !== (options.getMarkdownOutputPath === undefined))
        throw new Error("renderMarkdown and getMarkdownOutputPath must be configured together.");
    const artifacts = [{
            kind: "spa-shell",
            outputPath: options.spaShellOutputPath ?? "app-shell.html",
            contents: options.shell,
        }];
    const resourcesByPath = new Map();
    if (options.resourceCatalog)
        for await (const resource of options.resourceCatalog.iterate())
            if (resource.prerender)
                resourcesByPath.set(resource.path, resource);
    const prerenderPaths = new Set([
        ...options.site.getPrerenderPaths(),
        ...resourcesByPath.keys(),
    ]);
    for (const routePath of prerenderPaths) {
        const state = await options.createState(routePath, resourcesByPath.get(routePath));
        artifacts.push({
            kind: "page",
            routePath,
            outputPath: getPublicSsgPageOutputPath(routePath),
            contents: renderPublicHtmlDocument({
                shell: options.shell,
                appHtml: await options.renderRoute(routePath, state),
                head: options.resolveHead(routePath, resourcesByPath.get(routePath)),
                state,
                dom: options.dom,
            }),
        });
        const route = options.site.getRouteDefinition(routePath);
        if (route?.access === "public"
            && route.render.kind === "ssg"
            && options.renderMarkdown
            && options.getMarkdownOutputPath)
            artifacts.push({
                kind: "markdown",
                routePath,
                outputPath: options.getMarkdownOutputPath(routePath),
                contents: await options.renderMarkdown(routePath),
            });
    }
    for (const variant of options.notFoundVariants) {
        artifacts.push({
            kind: "not-found",
            routePath: variant.routePath,
            outputPath: variant.outputPath,
            contents: renderPublicHtmlDocument({
                shell: options.shell,
                appHtml: await options.renderRoute(variant.routePath, variant.state),
                head: options.resolveNotFoundHead(variant.routePath),
                state: variant.state,
                dom: options.dom,
            }),
        });
    }
    for (const document of options.sitemapDocuments ?? []) {
        artifacts.push({
            kind: document.kind ?? "sitemap",
            outputPath: document.outputPath,
            contents: document.contents,
        });
    }
    for (const document of options.documents ?? [])
        artifacts.push({
            kind: document.kind ?? "document",
            outputPath: document.outputPath,
            contents: document.contents,
        });
    return artifacts;
}
//# sourceMappingURL=index.js.map